export const timetable=[
  {
    "displayText": "FIRST YEAR MSBTE ACADEMIC CALENDAR",
    "filename": "./assets/documentation/academic/timetable/FIRST YEAR MSBTE ACADEMIC CALENDAR.pdf",
    "link": ""
  },
  {
    "displayText": "MSBTE ACADEMIC CALENDAR",
    "filename": "./assets/documentation/academic/timetable/MSBTE ACADEMIC CALENDAR.pdf",
    "link": ""
  },
  {
    "displayText": "TIME TABLE 2025-26",
    "filename": "./assets/documentation/academic/timetable/TIME TABLE 2025-26.pdf",
    "link": ""
  }
]